import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c08eab3c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/checkout/_checkout.scss?vue&type=style&index=0&id=c08eab3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08eab3c",
  null
  
)

export default component.exports